/* SmartPaw — gedeelde logica voor de AI-vraagbot (homepagesectie + zwevende knop). v3, 18 okt 2026: winkelmandje-knop, meetpunten (anonieme gesprek-ID voor het vragenoverzicht)
   - Markdown-light (links, vet, lijstjes)
   - Keuzeknopjes: de bot eindigt een bijvraag met "OPTIES: a | b | c"
   - Productkaartjes: elke link naar /products/<handle> krijgt een kaartje (foto, prijs, knop)
   - Optioneel gesprek bewaren tussen pagina's (opts.persistKey, sessionStorage) */
(function () {
  if (window.SPVraag) return;

  var OPT_RE = /^\s*\**\s*(OPTIES|OPTIONS|OPTIONS?)\s*\**\s*:\s*(.+)$/i;

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function safeUrl(u) {
    u = u.trim();
    if (/^https?:\/\//i.test(u) || /^mailto:/i.test(u) || /^\//.test(u)) return u;
    return null;
  }
  function localize(u) {
    // Productlinks op de huidige site houden (ook in preview/andere taal)
    var m = u.match(/^https?:\/\/(?:www\.)?smartpaw\.be(\/.*)?$/i);
    return m ? (m[1] || '/') : u;
  }
  function inline(s) {
    s = esc(s);
    s = s.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (m, txt, url) {
      var u = safeUrl(url.replace(/&amp;/g, '&'));
      if (!u) return txt;
      u = localize(u);
      var ext = /^https?:/i.test(u) && u.indexOf(location.hostname) === -1;
      return '<a href="' + esc(u) + '"' + (ext ? ' target="_blank" rel="noopener"' : '') + '>' + txt + '</a>';
    });
    return s.replace(/\*\*([^*]+)\*\*/g, '<b>$1</b>');
  }
  function split(md) {
    var lines = String(md).replace(/\s+$/, '').split(/\n/), opts = [];
    for (var i = lines.length - 1; i >= 0; i--) {
      var m = lines[i].match(OPT_RE);
      if (m) {
        opts = m[2].split('|').map(function (x) { return x.replace(/\*/g, '').trim(); }).filter(Boolean).slice(0, 4);
        lines.splice(i, 1);
        break;
      }
      if (lines[i].trim()) break;
    }
    return { text: lines.join('\n'), options: opts };
  }
  function render(md) {
    var lines = String(md).split(/\n/), out = '', inList = false, para = [];
    function flush() { if (para.length) { out += '<p>' + inline(para.join(' ')) + '</p>'; para = []; } }
    lines.forEach(function (l) {
      var m = l.match(/^\s*(?:[-*•]|\d+[.)])\s+(.*)$/);
      if (m) { flush(); if (!inList) { out += '<ul>'; inList = true; } out += '<li>' + inline(m[1]) + '</li>'; return; }
      if (inList) { out += '</ul>'; inList = false; }
      if (!l.trim()) { flush(); return; }
      para.push(l.trim());
    });
    flush(); if (inList) out += '</ul>';
    return out;
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '€' + (cents / 100).toFixed(2).replace('.', ','); }
  }
  var SID = (function () {
    var id = '';
    try { id = sessionStorage.getItem('spAskSid') || ''; } catch (e) {}
    if (!id) {
      id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      try { sessionStorage.setItem('spAskSid', id); } catch (e) {}
    }
    return id;
  })();
  /* Meten: GA4 (gtag/dataLayer), Meta (fbq) en Shopify customer events. Faalt nooit hard. */
  function track(name, params) {
    params = params || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'sp_chat_' + name }, params)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', 'sp_chat_' + name, params); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', 'SPChat_' + name, params); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('sp_chat_' + name, params); } catch (e) {}
  }
  function refreshCartCount() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-header-cart-count], .cart-count, [data-cart-count]'), function (el) { el.textContent = c.item_count; });
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: c })); } catch (e) {}
    }).catch(function () {});
  }
  var cardCache = {};
  function productCards(bubble, labels) {
    var seen = {}, handles = [];
    Array.prototype.forEach.call(bubble.querySelectorAll('a[href*="/products/"]'), function (a) {
      var m = a.getAttribute('href').match(/\/products\/([a-z0-9\-_]+)/i);
      if (m && !seen[m[1]] && handles.length < 2) { seen[m[1]] = 1; handles.push(m[1]); }
    });
    if (!handles.length) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var wrap = document.createElement('div');
    wrap.className = 'vb-cards';
    bubble.appendChild(wrap);
    handles.forEach(function (h) {
      var p = cardCache[h] || (cardCache[h] = fetch(root + 'products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }));
      p.then(function (d) {
        var img = d.featured_image ? (d.featured_image.indexOf('//') === 0 ? 'https:' + d.featured_image : d.featured_image) : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        var was = d.compare_at_price && d.compare_at_price > d.price ? '<s>' + money(d.compare_at_price) + '</s>' : '';
        var avail = (d.variants || []).filter(function (v) { return v.available; });
        var oneVariant = (d.variants || []).length === 1 && avail.length === 1;
        var url = root + 'products/' + d.handle;
        var card = document.createElement('div');
        card.className = 'vb-card';
        card.innerHTML = '<a class="vb-card-l" href="' + esc(url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') +
          '<span class="vb-card-t"><b>' + esc(d.title) + '</b><span>' + money(d.price) + ' ' + was + '</span></span></a>' +
          (oneVariant
            ? '<button type="button" class="vb-card-go vb-card-add">' + esc(labels.add || '+ Mandje') + '</button>'
            : '<a class="vb-card-go" href="' + esc(url) + '">' + esc(d.available ? labels.view : labels.soldout) + '</a>');
        card.querySelector('.vb-card-l').addEventListener('click', function () { track('card_click', { product: d.handle }); });
        var go = card.querySelector('a.vb-card-go');
        if (go) go.addEventListener('click', function () { track('card_click', { product: d.handle }); });
        var add = card.querySelector('.vb-card-add');
        if (add) add.addEventListener('click', function () {
          if (add.disabled) return;
          add.disabled = true; add.textContent = '…';
          var v = avail[0];
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
            .then(function (r) { if (!r.ok) throw 0; return r.json(); })
            .then(function () {
              add.outerHTML = '<a class="vb-card-go vb-card-ok" href="' + esc(root + 'cart') + '">' + esc(labels.tocart || '✓ Naar mandje') + '</a>';
              refreshCartCount();
              var val = v.price / 100, cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
              track('add_to_cart', { product: d.handle, variant_id: v.id, value: val, currency: cur });
              try { if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_ids: [String(v.id)], content_type: 'product', value: val, currency: cur }); } catch (e) {}
              try { if (typeof window.gtag === 'function') window.gtag('event', 'add_to_cart', { currency: cur, value: val, items: [{ item_id: String(v.id), item_name: d.title, price: val, quantity: 1 }] }); } catch (e) {}
            })
            .catch(function () { location.href = url; });
        });
        wrap.appendChild(card);
      }).catch(function () {});
    });
  }

  /* root moet bevatten: form.vb-form, .vb-in-field, button.vb-go, .vb-log; optioneel .vb-foot, .vb-reset, .vb-chips/.vb-chip, .vb-welcome */
  function mount(root, opts) {
    if (!root || root.dataset.vbReady) return;
    root.dataset.vbReady = '1';
    opts.labels = opts.labels || { view: 'Bekijk', soldout: 'Uitverkocht' };
    var form = root.querySelector('.vb-form'),
        input = root.querySelector('.vb-in-field'),
        btn = root.querySelector('.vb-go'),
        log = root.querySelector('.vb-log'),
        foot = root.querySelector('.vb-foot'),
        reset = root.querySelector('.vb-reset'),
        chips = root.querySelector('.vb-chips'),
        scroller = root.querySelector(opts.scroller || '.vb-log') || log,
        history = [], busy = false;

    function save() {
      if (!opts.persistKey) return;
      try { sessionStorage.setItem(opts.persistKey, JSON.stringify(history.slice(-20))); } catch (e) {}
    }
    function toBottom() { setTimeout(function () { scroller.scrollTop = scroller.scrollHeight; log.scrollTop = log.scrollHeight; }, 30); }
    function bubble(cls, html) {
      var d = document.createElement('div');
      d.className = 'vb-msg ' + cls;
      d.innerHTML = html;
      log.appendChild(d);
      log.classList.add('on');
      root.classList.add('vb-has-chat');
      toBottom();
      return d;
    }
    function clearOptions() {
      Array.prototype.forEach.call(log.querySelectorAll('.vb-opts'), function (o) { o.remove(); });
    }
    function showAnswer(el, raw, live) {
      var parts = split(raw);
      el.innerHTML = render(parts.text);
      productCards(el, opts.labels);
      if (live && parts.options.length) {
        var o = document.createElement('div');
        o.className = 'vb-opts';
        parts.options.forEach(function (t) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'vb-opt'; b.textContent = t;
          b.addEventListener('click', function () { ask(t); });
          o.appendChild(b);
        });
        log.appendChild(o);
      }
      toBottom();
    }
    function ask(q) {
      q = (q || '').trim();
      if (!q || busy) return;
      busy = true; btn.disabled = true; input.value = '';
      if (input.tagName === 'TEXTAREA') input.style.height = '';
      clearOptions();
      if (chips && opts.hideChipsAfterAsk) chips.style.display = 'none';
      bubble('vb-q', esc(q));
      track('question', { page: location.pathname, lang: opts.lang });
      var wait = bubble('vb-a', '<span class="vb-dots" aria-label="' + esc(opts.wait) + '"><span></span><span></span><span></span></span>');
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 30000);
      fetch(opts.api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ question: q, history: history.slice(-10), lang: opts.lang, page: location.pathname, sid: SID }),
        signal: ctl ? ctl.signal : undefined
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || !j.answer) throw new Error(j.error || r.status); return j; }); })
        .then(function (j) {
          history.push({ role: 'user', content: q }, { role: 'assistant', content: j.answer });
          save();
          showAnswer(wait, j.answer, true);
          if (foot) foot.classList.add('on');
        })
        .catch(function () { wait.classList.add('err'); wait.textContent = opts.err; })
        .finally(function () { clearTimeout(timer); busy = false; btn.disabled = false; toBottom(); });
    }

    // Eerder gesprek terugzetten (zwevend venster, tussen pagina's)
    if (opts.persistKey) {
      try { history = JSON.parse(sessionStorage.getItem(opts.persistKey) || '[]') || []; } catch (e) { history = []; }
      if (history.length) {
        if (chips && opts.hideChipsAfterAsk) chips.style.display = 'none';
        history.forEach(function (m, i) {
          if (m.role === 'user') bubble('vb-q', esc(m.content));
          else showAnswer(bubble('vb-a', ''), m.content, i === history.length - 1);
        });
        if (foot) foot.classList.add('on');
      }
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
    if (input.tagName === 'TEXTAREA') {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); ask(input.value); }
      });
      input.addEventListener('input', function () {
        input.style.height = 'auto';
        input.style.height = Math.min(input.scrollHeight, 110) + 'px';
      });
    }
    Array.prototype.forEach.call(root.querySelectorAll('.vb-chip'), function (c) {
      c.addEventListener('click', function () { ask(c.getAttribute('data-q') || c.textContent); });
    });
    if (reset) reset.addEventListener('click', function () {
      history = []; save(); log.innerHTML = ''; log.classList.remove('on'); root.classList.remove('vb-has-chat');
      if (foot) foot.classList.remove('on');
      if (chips) chips.style.display = '';
      input.focus();
    });
    return { ask: ask };
  }

  window.SPVraag = { mount: mount, track: track };
})();
